module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data rozpoczęcia",
      "error": _vm.errors.start_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data rozpoczecia sprzedaży"
    },
    model: {
      value: (_vm.form.start_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_date", $$v)
      },
      expression: "form.start_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Data zakończenia",
      "error": _vm.errors.end_date
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy/MM/dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Data rozpoczecia sprzedaży"
    },
    model: {
      value: (_vm.form.end_date),
      callback: function($$v) {
        _vm.$set(_vm.form, "end_date", $$v)
      },
      expression: "form.end_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sold out"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.sold_out),
      callback: function($$v) {
        _vm.$set(_vm.form, "sold_out", $$v)
      },
      expression: "form.sold_out"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f48f95d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tickets/PeriodForm.vue
// module id = 742
// module chunks = 0